/* Studio Next — "More" menus for sizes and quantities.
   The first five options stay in the row; the rest (7"–10" + Custom, 200+) open in a
   small floating menu, so the panel never grows. When the current choice is one of
   the extras, the "More" button shows it (e.g. "8″ ▾", "1k ▾") and is highlighted.
   Picking an item clicks the builder's own (hidden) option, so pricing, minimum-order
   rules and the custom-size panel all behave exactly as before.
   Applies to the editor panel and the phone "Design Your Sticker" specs screen. */
/* overlays live in #smnLayer, not directly in <body>: the builder CSS resets padding/transform/max-width on
   every direct body child, which breaks centred pop-ups */
window.smnLayer = window.smnLayer || function () { var l = document.getElementById('smnLayer'); if (!l) { l = document.createElement('div'); l.id = 'smnLayer'; document.body.appendChild(l); } return l; };
(function () {
  'use strict';
  function start() {
    var S = (window.SMN && window.SMN.state) || window._sms || {};
    var $ = function (s, r) { return (r || document).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

    var pop = document.createElement('div');
    pop.className = 'smui-pop'; pop.hidden = true; pop.setAttribute('role', 'menu');
    window.smnLayer().appendChild(pop);
    var openFor = null, groups = [];

    function close() { pop.hidden = true; if (openFor) openFor.btn.setAttribute('aria-expanded', 'false'); openFor = null; }
    function open(g) {
      if (openFor === g) return close();
      close();
      pop.innerHTML = '';
      g.extras.forEach(function (x) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('role', 'menuitem');
        b.textContent = x.label;
        if (g.isOn(x)) b.className = 'on';
        // the builder greys out quantities that break its minimum/maximum rules — mirror that here
        if (x.el.classList.contains('sms-locked') || x.el.disabled) { b.disabled = true; b.title = x.el.title || 'Not available for this size'; }
        b.onclick = function () { close(); x.pick(); setTimeout(sync, 50); };
        pop.appendChild(b);
      });
      pop.style.gridTemplateColumns = 'repeat(' + Math.min(3, g.extras.length) + ', minmax(0, 1fr))';
      pop.hidden = false; pop.style.removeProperty('display');
      var r = g.btn.getBoundingClientRect(), cr = g.c.getBoundingClientRect();
      var w = Math.min(Math.max(cr.width * 0.62, 200), cr.width);
      pop.style.width = w + 'px';
      pop.style.left = Math.max(8, Math.min(r.right - w, window.innerWidth - w - 8)) + 'px';
      var below = r.bottom + 6, h = pop.offsetHeight;
      pop.style.top = (below + h > window.innerHeight - 8 ? r.top - h - 6 : below) + 'px';
      g.btn.setAttribute('aria-expanded', 'true');
      openFor = g;
    }
    document.addEventListener('pointerdown', function (e) { if (openFor && !pop.contains(e.target) && e.target !== openFor.btn && !openFor.btn.contains(e.target)) close(); }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    // phones fire resize when the address bar slides in/out — only a width change should close the menu
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; close(); } });
    document.addEventListener('scroll', close, true);

    function addMore(container, extras, current, title) {
      if (!container || !extras.length || container.querySelector(':scope > .smui-more')) return;
      extras.forEach(function (x) { x.el.classList.add('smui-extra'); });
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'smui-more'; btn.title = title;
      btn.setAttribute('aria-haspopup', 'menu'); btn.setAttribute('aria-expanded', 'false');
      container.classList.add('smui-has-more');
      container.appendChild(btn);
      var g = { c: container, btn: btn, extras: extras, isOn: function (x) { return String(current()) === String(x.value); } };
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(g); });
      groups.push(g);
    }
    function sync() {
      groups.forEach(function (g) {
        var cur = g.extras.filter(g.isOn)[0];
        g.btn.classList.toggle('on', !!cur);
        // long choices ("Custom") drop the caret so they fit the column
        var h = (cur ? cur.label : 'More') + (cur && cur.label.length > 4 ? '' : '<i>▾</i>'), pp = cur && window.DTF && DTF.morePrice ? DTF.morePrice(cur.value) : '';
        if (pp && cur.label.indexOf(pp) < 0) h = '<span>' + h + '</span><small class="dtf-pp">' + pp + '</small>';
        if (g.h !== h) { g.h = h; g.btn.innerHTML = h; }
      });
    }

    var BIG = ['25x72', '25x84', '25x96', '25x120', '25x144', '25x180', '25x240', '25x288', '25x360', 'custom'];
    var MANYQ = [10, 15, 20, 25, 50, 100];
    var curSize = function () { return S.size || (window._specS && window._specS.size); };
    var curQty = function () { return +(S.qty || (window._specS && window._specS.qty)); };
    var specSize = function () { return (window._specS && window._specS.size) || curSize(); };
    var specQty = function () { return +((window._specS && window._specS.qty) || curQty()); };
    function txt(el) { return (el.textContent || '').trim(); }

    // editor panel: sizes (hidden radio + label pairs inside .sms-sizes)
    var sizes = $('.sms-sizes');
    if (sizes) {
      var ex = [];
      BIG.forEach(function (v) {
        var r = $('input[type=radio][value="' + v + '"]', sizes); if (!r) return;
        var l = r.id && $('label[for="' + r.id + '"]', sizes); if (!l) return;
        ex.push({ el: l, value: v, label: txt(l), pick: function () { l.click(); } });
      });
      addMore(sizes, ex, curSize, 'More sizes');
    }
    // editor panel: quantity presets
    var qp = $('.sms-qty-presets');
    if (qp) addMore(qp, $$('.sms-qty-pre', qp).filter(function (b) { return MANYQ.indexOf(+b.dataset.qty) > -1; })
      .map(function (b) { return { el: b, value: +b.dataset.qty, label: txt(b), pick: function () { b.click(); } }; }), curQty, 'More quantities');
    // phone specs screen
    var ssp = $('#sl2SizePills');
    if (ssp) addMore(ssp, $$('[data-size]', ssp).filter(function (b) { return BIG.indexOf(b.dataset.size) > -1; })
      .map(function (b) { return { el: b, value: b.dataset.size, label: txt(b), pick: function () { b.click(); } }; }), specSize, 'More sizes');
    var sqp = $('#sl2QtyPills');
    if (sqp) addMore(sqp, $$('[data-qty]', sqp).filter(function (b) { return MANYQ.indexOf(+b.dataset.qty) > -1; })
      .map(function (b) { return { el: b, value: +b.dataset.qty, label: txt(b), pick: function () { b.click(); } }; }), specQty, 'More quantities');

    // custom W×H: keep typed values inside the inputs' own min/max (the builder didn't enforce max)
    ['smsCustomW', 'smsCustomH'].forEach(function (id) {
      var inp = document.getElementById(id); if (!inp) return;
      inp.addEventListener('change', function () {
        var v = parseFloat(inp.value), lo = parseFloat(inp.min), hi = parseFloat(inp.max);
        if (isNaN(v)) return;
        var c = Math.min(isNaN(hi) ? v : hi, Math.max(isNaN(lo) ? v : lo, v));
        if (c !== v) { inp.value = String(c); inp.dispatchEvent(new Event('input', { bubbles: true })); if (window.SMNX) window.SMNX.toast('Custom size is ' + (isNaN(lo) ? '' : lo + '–') + hi + '″', 'warn'); }
      });
    });

    sync();
    setInterval(sync, 400); // shared designs, undo, the phone specs screen etc. can change the choice
  }
  function boot() { if (window.SMN) start(); else document.addEventListener('smn:ready', start, { once: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
